//import clientAPI from "@/api/ClientAPIMixin.js";
import i18n from '@/plugins/i18n.js';

const AppointmentEditModel = {
    headerTitle: i18n.t('servicesystem.common_objects.appointment.appointment'),
    enabledIcon: "mdi-calendar",
    disabledIcon: "mdi-calendar",
    listItemTextKey: "Id",
    //ParentIdKey: "CustomerId",

    fields: [
        { type: "date", label: i18n.t('servicesystem.common_objects.appointment.date'), valuekey: "AppointmentDate", editable: true, rules: "", defaultValue: "" },
        { type: "time", label: i18n.t('servicesystem.common_objects.appointment.start'), valuekey: "StartTime", editable: true, rules: "", defaultValue: "" },
        { type: "time", label: i18n.t('servicesystem.common_objects.appointment.end'), valuekey: "EndTime", editable: true, rules: "", defaultValue: "" },
        { type: "userlist", label: i18n.t('servicesystem.common_objects.appointment.participants'), valuekey: "Participants", editable: true, rules: "", defaultValue: "" },
    ],

    viewMore: {
        routeName: "ViewJobPlanning",
        params: { filter: 'my', jobId: "JobId", appointmentId: "Id" }
    },

    methods: {

    }
}

export default AppointmentEditModel;